const rxdc = ({ selected: initialSelected, options: initialOptions, forceType }) => {
  // Enforce only the valid RX-DC configuration is selectable in all markets
  const { series } = initialSelected || {};
  let selected = { ...initialSelected };
  let options = initialOptions;

  if (series === "RX-DC") {
    // Only allow these codes for each component
    const validConfig = {
      seat: ["R"],
      back: ["X"],
      base: ["C"],
      control: ["S"],
      upholstery: ["XTBLK"],
      casters: ["RK"],
      height: ["XL"],
      footring: ["XF"],
      performance: ["K"],
    };

    // Filter options for each component
    options = options.map(({ type, data, ...rest }) => {
      if (validConfig[type]) {
        return {
          type,
          data: data.filter(({ code }) => validConfig[type].includes(code)),
          ...rest,
        };
      }
      return { type, data, ...rest };
    });

    // Force selected values to valid config
    Object.entries(validConfig).forEach(([type, allowed]) => {
      if (!allowed.includes(selected[type])) {
        selected[type] = allowed[0];
      }
    });
  }

  return { selected, options };
};

export default rxdc;
